<div class="flex flex-col basis-full m-20">
    <div class="flex flex-col">
      <div class="flex justify-end">
        <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
      </div>
      <div class="flex flex-col items-center mt-16">
        <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
        <div class="flex flex-row fw-700 fs-24 mt-16">
          {{'GENERIC_ERROR.ACTION_NOT_ALLOWED' | transloco}}          
        </div>
        <div class="flex justify-center mt-12 fw-500 not-authorized">
          {{'GENERIC_ERROR.NOT_AUTHORIZED' | transloco}}  
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-center items-center mb-20 mt-36">
      <button class="accent" type="button" (click)="matdialogRef.close()"> {{ 'BUTTONS.CLOSE' | transloco }} </button>
    </div>
  </div>
  